import * as C from './constants';

const receiveNetworkException = (err) => ({
  type: C.RECEIVE_NETWORK_EXCEPTION,
  data: err,
});

export default receiveNetworkException;
